export default "__VITE_ASSET__DXO8JrYM__"